import { initializeApp } from 'firebase'
import firebase from 'firebase'

var fireApp = initializeApp({
  apiKey: "AIzaSyCVrsCoQhCyVCeKasmSQ2UlOqPmH2eByF0",
  authDomain: "racepeps.firebaseapp.com",
  databaseURL: "https://racepeps.firebaseio.com",
  projectId: "racepeps",
  storageBucket: "voicemessages",
  messagingSenderId: "753012729250"
})

export const db = fireApp.database()
export const userRef = db.ref('users')
export const racePepsRef = db.ref('racepeps')
export const eventsRef = db.ref('events')
export const storage = firebase.storage().ref()
export const imageStorage = firebase.app().storage('gs://racepeps.appspot.com').ref()
